import { render } from "./step0.vue?vue&type=template&id=ad62447c&ts=true"
import script from "./step0.vue?vue&type=script&lang=ts"
export * from "./step0.vue?vue&type=script&lang=ts"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__